import * as z from "zod";
import { attachmentSchema, dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormMarkAsPerformed = z.object({
  dateDone: dateSchema,
  comment: zRequiredString("Veuillez saisir un commentaire"),
  attachedFiles: attachmentSchema,
});
